import type { ChangeEvent } from "react";

import { InputErrorMessage } from "./input-error-message";
import { InputWrapper } from "./input-wrapper";
import { RequiredAsterisk } from "./required-asterisk";

interface InputRadioProps {
  checked: boolean;
  disabled?: boolean;
  errorMessage?: string;
  id: string;
  label: string;
  /**
   * All radio buttons in a group must have the same name
   */
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  title?: string;
  value: string;
  autoComplete?: string;
}

export const InputRadio = ({
  checked,
  disabled,
  errorMessage,
  id,
  label,
  name,
  onChange,
  required,
  title,
  value,
  autoComplete,
}: InputRadioProps) => (
  <InputWrapper>
    <div className="checkbox-and-radio">
      <input
        checked={checked}
        className="checkbox-and-radio__input"
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        required={required}
        value={value}
        title={title}
        type="radio"
        autoComplete={autoComplete}
      />
      <label className="checkbox-and-radio__label" htmlFor={id} title={title}>
        {label}
      </label>
      {required && <RequiredAsterisk />}
    </div>

    <InputErrorMessage errorMessage={errorMessage} />
  </InputWrapper>
);
